import { defineComponent } from 'vue';
import OrderDetail from './components/orderInfo.vue';
import oldOrder from './components/oldOrder.vue';
import liveOrder from './components/liveOrder.vue';
import albumOrder from './components/albumOrder.vue';
import VipOrder from './components/vipOrder.vue';
export default defineComponent({
    name: 'orderpay',
    data() {
        return {
            omoOrder: false,
            moduleType: String(this.$route.params.module),
            livePage: String(this.$route.query.livePage)
        };
    },
    created() {
        if (this.moduleType == 'meeting') {
            this.omoOrder = true;
        }
        else {
            this.omoOrder = false;
        }
    },
    components: {
        OrderDetail,
        oldOrder,
        liveOrder,
        albumOrder,
        VipOrder
    },
    unmounted() {
        if (window.payCallback) {
            delete window.payCallback;
        }
    }
});
